import { type UserSettings } from '../../../../api/types';
import UserDetailForm from './UserDetailForm';

export type UserFormValues = UserSettings;

export { default as useUserFormValidator } from './useUserFormValidator';

export const defaultValues: UserFormValues = {
    displayName: '',
    email: '',
    roleIds: [],
    userGroupIds: [],
    mobile: { value: '', prefix: null },
    isActive: false,
};

const UserForm = () => <UserDetailForm />;

export default UserForm;
